const axios = require('axios');

const listener = (event) => {
  const confirmationMessage = 'Há uma chamada em curso, deseja realmente sair?';

  event.returnValue = confirmationMessage;

  return confirmationMessage;
};

let telephony;

const call = {
  idCall: '',
  called: '',
  status: '',
  duration: '',
  audioLink: '',
};

const statuses = {
  busy: 'Destinatário ocupado',
  failed: 'Chamada falhou',
  received: 'Iniciando...',
  finished: 'Chamada finalizada',
  noanswer: 'Chamada não atendida',
  established: 'Chamada em andamento',
  calling_origin: 'Chamando {{caller}}...',
  calling_destination: 'Chamando {{called}}...',
};

export default class {
  textStatus () {
    if (statuses[call.status]) {
      return statuses[call.status].replace('{{caller}}', telephony.caller).replace('{{called}}', call.called);
    }

    return 'Iniciando...';
  }

  startCall (data) {
    telephony = data;
    telephony.countFailure = 3;

    this.addExitConfirm();

    call.called = data.called;
    call.idCall = '';
    call.duration = '';
    call.status = '';
    call.audioLink = '';

    axios.post(`${data.host}/v1/calls`, {
      caller: data.caller,
      called: call.called,
    }, {
      headers: {
        token_auth: telephony.token,
      },
    })
      .then((response) => {
        call.idCall = response.data.callId;
        call.status = response.data.state;

        this.checkCall(call.idCall);
      })
      .catch((error) => {
        console.log(error.response);

        this.removeExitConfirm();

        Alert.error('Não foi possível efetuar a chamada. Verifique suas configurações.');
      });
  }

  endCall () {
    if (call.idCall) {
      axios.post(`${telephony.host}/v1/calls/endcall`, {
        callId: call.idCall,
      }, {
        headers: {
          token_auth: telephony.token,
        },
      });
    }
  }

  checkCall (idCall) {
    const warn = ['failed'];
    const off = ['busy', 'noanswer', 'finished'];
    const on = ['calling_origin', 'calling_destination', 'established'];

    axios.get(`${telephony.host}/v1/calls/${idCall}`, {
      headers: {
        token_auth: telephony.token,
      },
      contentType: 'application/json; charset=utf-8',
    })
      .then((response) => {
        call.status = response.data.state;
        call.duration = response.data.talkingDurationSeconds;
        call.audioLink = response.data.linkAudio;

        if (on.indexOf(call.status) >= 0) {
          return setTimeout(() => this.checkCall(call.idCall), 2000);
        }

        if (off.indexOf(call.status) >= 0) {
          return this.saveActivity();
        }

        if (warn.indexOf(call.status) >= 0) {
          Alert.error('Não foi possível efetuar a chamada. Verifique se o discador está aberto.');
        }

        this.removeExitConfirm();
      })
      .catch((error) => {
        if (telephony.countFailure-- > 0) {
          setTimeout(() => this.checkCall(call.idCall), 2000);
        } else {
          this.saveActivity();
        }
      });
  }

  saveActivity () {
    const activity = {
      type: 'call',
      content: '',
      data: call,
      user: telephony.data.user,
      scheduled_at: null,
    };

    Bus.$emit(`saveActivity-${telephony.data.hash}`, telephony.data.hash, activity);

    this.removeExitConfirm();
  }

  addExitConfirm () {
    Bus.$emit(`startCall-${telephony.data.hash}`);

    window.addEventListener('beforeunload', listener);
  }

  removeExitConfirm () {
    Bus.$emit(`endCall-${telephony.data.hash}`);

    window.removeEventListener('beforeunload', listener);
  }
}
